// src/pages/AddLicense.js
import React, { useState, useEffect } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import { useNavigate } from "react-router-dom";

export default function AddLicense() {
    const [licenseCard, setLicenseCard] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!licenseCard.trim()) {
            alert("Le nom de la licence est obligatoire.");
            return;
        }

        try {
            setLoading(true);
            await api.post("/license-cards", { license_card: licenseCard });
            alert("Licence ajoutée avec succès !");
            navigate("/license-list");
        } catch (err) {
            console.error(err);
            alert("Erreur lors de l'ajout de la licence.");
        } finally {
            setLoading(false);
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6 max-w-md">
            <h1 className="text-2xl font-bold mb-6 dark:text-white">Ajouter une Licence (carte)</h1>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block font-semibold mb-1">Nom de la licence</label>
                    <input
                        type="text"
                        value={licenseCard}
                        onChange={(e) => setLicenseCard(e.target.value)}
                        className="border rounded px-3 py-2 w-full dark:bg-gray-700 bg-white"
                        placeholder=""
                        required
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded px-4 py-2"
                >
                    {loading ? "Ajout en cours..." : "Ajouter"}
                </button>
            </form>
        </div>
    );
}
